import React, { Fragment } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { FileText } from 'lucide-react';

const DocumentPreviewModal = ({ 
  docPreviewOpen, 
  selectedDocument, 
  handleCloseDocumentPreview, 
  company 
}) => {
  if (!selectedDocument?.url) {
    return (
      <Transition appear show={docPreviewOpen} as={Fragment}>
        <Dialog as="div" className="relative z-50" onClose={handleCloseDocumentPreview}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white shadow-xl transition-all">
                  <div className="p-6 text-center">
                    <FileText className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                    <Dialog.Title className="text-lg font-semibold text-gray-900 mb-2">
                      Document Preview Unavailable
                    </Dialog.Title>
                    <p className="text-sm text-gray-600 mb-4">
                      This document was uploaded before the preview feature was implemented. 
                      The document URL is not available for preview.
                    </p>
                    <div className="text-xs text-gray-500 mb-6 p-3 bg-gray-50 rounded-lg">
                      <div><strong>Document:</strong> {selectedDocument?.name}</div>
                      <div><strong>File:</strong> {selectedDocument?.fileName}</div>
                      {selectedDocument?.lastUpdated && (
                        <div><strong>Updated:</strong> {new Date(selectedDocument.lastUpdated).toLocaleDateString()}</div>
                      )}
                    </div>
                    <div className="flex gap-3">
                      <button
                        onClick={handleCloseDocumentPreview}
                        className="flex-1 px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
                      >
                        Close
                      </button>
                      {company.teamMembers?.[0]?.email && (
                        <a
                          href={`mailto:${company.teamMembers[0].email}?subject=Document Preview Issue - ${selectedDocument?.name}&body=Hi, I'm trying to view the document "${selectedDocument?.name}" but the preview is not available. Could you please help?`}
                          className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-center"
                        >
                          Contact Us
                        </a>
                      )}
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    );
  }

  return null;
};

export default DocumentPreviewModal; 